// @flow
import React from 'react';
import prop from 'ramda/es/prop';
import classNames from 'classnames/bind';

import styles from './Status.module.scss';;


const cx = classNames.bind(styles);

type Props = {
  status: 'active' | 'deleted' | 'inactive',
}

const Status = ({ status }: Props) => {
  const statusClassName = prop(status, styles);
  const className = cx(styles.root, statusClassName);

  return (
    <span className={className}>{'●'}</span>
  );
};

export default Status;
